import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import { PaymentSetData } from "../../store/admin/reports/details_finance_report";


const getList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.flatFee.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const deleteFlatFee = (id: any)  => {
  const authenticity_token = getCookie(cookieToken);

	const payload = {
		authenticity_token: authenticity_token,
	}

	const endpoint = api.admin.flatFee.delete.replace('{flatFeeId}', `${id}`);

	return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const createFlatFee = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	}

	const endpoint = api.admin.flatFee.create;

	return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('POST', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const updateFlatFee = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	}

	const endpoint = api.admin.flatFee.update.replace('{flatFeeId}', `${data.flatFeeId}`);

	return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('PUT', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const setDownload = (data: any) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = api.admin.flatFee.download;

	const payload = {
		...data.payload,
		authenticity_token: authenticity_token,
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('POST', JSON.stringify(payload))}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const getPayouts = (data:any) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = api.admin.flatFee.payoutsList.replace('{flatFeeId}', `${data.flatFeeId}`);

	const payload = {
		authenticity_token: authenticity_token,
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('POST', JSON.stringify(payload))}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

const createPayout = (data:any) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = `${api.admin.flatFee.createPayout.replace('{flatFeeId}', `${data.flatFeeId}`)}`;

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('POST', JSON.stringify(payload))}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

const updatePayout = (data:any) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = `${api.admin.flatFee.updatePayout.replace('{paymentId}', `${data.paymentId}`)}`;

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('PUT', JSON.stringify(payload))}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

const removePayout = (data:any) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = `${api.admin.flatFee.removePayout.replace('{paymentId}', `${data.paymentId}`)}`;

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('DELETE', JSON.stringify(payload))}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

const setPayment = (data: PaymentSetData) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = `${api.admin.reports.finance_report.detailed.payment.change}`;

	const payload = {
		...data,
		authenticity_token: authenticity_token
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('POST', JSON.stringify(payload))}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

const getAvailablePayments = (data: any) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = `${api.admin.affiliateProfile.payment.list
		.replace('{affiliateId}', `${data.affiliateId}`)}`;

	const payload = {
		...data.payload,
		authenticity_token: authenticity_token
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('GET')}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

const editPayment = (data: any) => {
	const authenticity_token = getCookie(cookieToken);

	const endpoint = `${api.admin.reports.finance_report.detailed.availablePayments
		.replace('{periodId}', `${data.periodId}`).replace('{affiliateId}', `${data.affiliateId}`)}`;

	const payload = {
		...data.payload,
		authenticity_token: authenticity_token
	};

	const headers = {
		...(data.hasOwnProperty('auth_type') ? {"auth-type": data.auth_type} : {}),
		...(data.hasOwnProperty('auth_code') ? {"auth-code": data.auth_code} : {}),
	};

	return fetch(
		`${endpoint}`,
		{...RequestOptions('PUT', JSON.stringify(payload), headers)}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
}

export const flatFeeService = {
	getList,
	deleteFlatFee,
	createFlatFee,
	updateFlatFee,
	setDownload,
	getPayouts,
	createPayout,
	updatePayout,
	removePayout,
	setPayment,
	getAvailablePayments,
	editPayment,
};
